import { IHeaderParams } from "@ag-grid-community/core";
import React from "react";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { useDataTableColumnSortProps } from "shared/components/table/data/internal/DataTableColumnSort";
import { useBuildDataTableColumnContext } from "shared/components/table/data/internal/DataTableContextBuilders";
import { DataTableHeaderRenderer } from "shared/components/table/data/internal/DataTableHeaderRenderer";
import { useMaybernTableColumnFilterState } from "shared/components/table/maybern/MaybernTableColumnFilter";

export const DataTableHeaderComponent: React.FC<IHeaderParams> = (props) => {
  const tableContext = props.context as DataTableContext;
  const columnContext = useBuildDataTableColumnContext(
    tableContext,
    props.column,
  );
  const { columnSort, onClickColumnSort } = useDataTableColumnSortProps(props);
  const { isFilterActive, showColumnFilter } =
    useMaybernTableColumnFilterState(props);
  return (
    <DataTableHeaderRenderer
      tableContext={tableContext}
      columnContext={columnContext}
      columnSort={columnSort}
      onClickColumnSort={onClickColumnSort}
      isFilterActive={isFilterActive}
      onClickColumnFilter={showColumnFilter}
    />
  );
};
